import { AnimatePresence, motion } from 'motion/react';
import { BaleOutboundContextProvider, BaleOutboundPageType } from './context';
import { BaleOutboundErrorHandler } from './error-handler';
import { useBaleOutboundContext } from './hook';
import { BaleOutboundAddLoadPhotosPage } from './subroutes/add-load-photos';
import { BaleOutboundConfirmSubmissionPage } from './subroutes/confirm-submission';
import { BaleOutboundDocketAddPhotoPage } from './subroutes/docket-photo';
import { BaleOutboundRootPage } from './subroutes/outbound-root';
import { BaleOutboundAddScanPage } from './subroutes/scan-add';
import { BaleOutboundRemoveScanPage } from './subroutes/scan-remove';
import { BaleOutboundSuccessPage } from './subroutes/success';

export const FacilityBaleOutboundPage = () => {
	return (
		<BaleOutboundContextProvider>
			<BaleOutboundPageRoot />
		</BaleOutboundContextProvider>
	);
};

const BaleOutboundPageRoot = () => {
	return (
		<>
			<AnimatePresence>
				<SubRoute key="ROOT" id="ROOT" component={<BaleOutboundRootPage />} />
				<SubRoute key="ADD_SCAN" id="ADD_SCAN" component={<BaleOutboundAddScanPage />} />
				<SubRoute key="REMOVE_SCAN" id="REMOVE_SCAN" component={<BaleOutboundRemoveScanPage />} />
				<SubRoute
					key="ADD_DOCKET_PHOTO"
					id="ADD_DOCKET_PHOTO"
					component={<BaleOutboundDocketAddPhotoPage />}
				/>
				<SubRoute
					key="ADD_LOAD_PHOTOS"
					id="ADD_LOAD_PHOTOS"
					component={<BaleOutboundAddLoadPhotosPage />}
				/>
				<SubRoute
					key="CONFIRM_SUBMISSION"
					id="CONFIRM_SUBMISSION"
					component={<BaleOutboundConfirmSubmissionPage />}
				/>
				<SubRoute id="SUCCESS" component={<BaleOutboundSuccessPage />} />
			</AnimatePresence>
			<BaleOutboundErrorHandler />
		</>
	);
};

const SubRoute = ({ id, component }: { id: BaleOutboundPageType; component: React.ReactNode }) => {
	const { page } = useBaleOutboundContext();

	if (page !== id) return null;

	return (
		<motion.div
			key={id}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.3 }}
		>
			{component}
		</motion.div>
	);
};
